import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Layout from '../components/Layout';
import Container from '../components/Container';
import Meta from '../components/Meta';
import Breadcrumb from '../components/Breadcrumb';

const DoNotSell = () => {
  const { t } = useTranslation('do-not-sell');

  return (
    <Layout className="do-not-sell">
      <Meta
        title={t('do-not-sell:meta.title')}
        description={t('do-not-sell:meta.description')}
      />
      <Container narrow>
        <Breadcrumb>
          <Breadcrumb.Item href="/">
            {t('common:nav.index')}
          </Breadcrumb.Item>
          <Breadcrumb.Item active>
            {t('common:nav.do-not-sell')}
          </Breadcrumb.Item>
        </Breadcrumb>
        <article className="content">
          <h1>
            {t('do-not-sell:intro.title')}
          </h1>
          <p>
            {t('do-not-sell:intro.text_1')}
          </p>
          <p>
            {t('do-not-sell:intro.text_2')}
          </p>
          <p>
            {t('do-not-sell:intro.text_3')}
          </p>
        </article>
      </Container>
    </Layout>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...await serverSideTranslations(locale, [
      'common',
      'do-not-sell',
    ]),
  },
});

export default DoNotSell;
